// extracted by mini-css-extract-plugin
export default {"button":"OzkkO","title":"iClfT","image":"ANBhr","cnImage":"OiAyC"};